import React from "react"

import { useTranslation } from "@bounce/i18n"

import { EventSuggestions } from "../../../../components/LuggageStorage/EventSuggestions/EventSuggestions"
import type { FormattedEvent } from "../../../../libs/prismic/event/types"

export type EventsProps = {
  events: FormattedEvent[]
  cityName: string
  citySlug: string
  className?: string
}

export const Events = ({ events, className, cityName, citySlug }: EventsProps) => {
  const [t] = useTranslation("marketing-ls-event")

  return (
    <EventSuggestions
      title={t("screen.event.moreEventsForYou", "More events for you", { cityName })}
      events={events}
      className={className}
      cityName={cityName}
      citySlug={citySlug}
    />
  )
}
